import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, ArrowRight, Paperclip } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Loader } from "@/components/public/Bits";
import { Reveal } from "@/components/Reveal";

export default function Events() {
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/public/events").then((r) => setEvents(r.data)).catch(() => setEvents([])); }, []);

  return (
    <div>
      <PageHeader eyebrow="Calendar" title="Events" subtitle="Upcoming and past events." kanji="空手道" />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        {events === null ? (
          <Loader />
        ) : events.length === 0 ? (
          <EmptyState icon={CalendarDays} kanji="空手道" title="No events scheduled" message="Upcoming events will appear here once published." testid="events-empty" />
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {events.map((e, i) => (
              <Reveal key={e.id} delay={Math.min(i * 0.05, 0.3)}>
                <Link to={`/events/${e.id}`} data-testid={`event-card-${e.id}`}
                  className="group flex gap-5 rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:border-ukf-gold hover:shadow-md">
                  <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-lg bg-ukf-red text-white">
                    <span className="font-serif text-3xl font-bold leading-none">{new Date(e.date).getDate()}</span>
                    <span className="mt-1 text-[10px] font-semibold uppercase tracking-wide">
                      {new Date(e.date).toLocaleDateString("en-GB", { month: "short", year: "numeric" })}
                    </span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-serif text-xl font-semibold text-ukf-ink group-hover:text-ukf-red">{e.name}</h3>
                    {e.location && (
                      <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-500">
                        <MapPin className="h-3.5 w-3.5" /> {e.location}
                      </p>
                    )}
                    {e.description && <p className="mt-2 line-clamp-2 text-sm text-slate-600">{e.description}</p>}
                    <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-ukf-red">
                      Details {e.media?.length > 0 && <Paperclip className="ml-1 h-3.5 w-3.5" />}
                      <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
